import React, { FC } from "react";
import { navigate } from "gatsby";
import { Banner } from "@ifgengineering/component-library";

export const TaxResidencyBanner: FC = () => {
  return (
    <Banner
      testId="tax-residency-link"
      text="You need to add your tax residency to be able to invest."
      CTAText="Add Tax Residency"
      onClickCTA={() =>
        navigate("/app/account?tab=profile&section=tax-residency", {
          state: { tabId: "profile" },
        })
      }
    />
  );
};
